import { type FunctionComponent } from 'react';
import { useStreetPageQuery } from '../../graphql/useStreetPageQuery';
import { StreetPageBanner } from './StreetPageBanner';

export const StreetPageBannerWithData: FunctionComponent = () => {
  const streetPageBySlug = useStreetPageQuery()?.data?.streetPageBySlug;
  const mediaPartnerBanner = streetPageBySlug?.mediaPartnerBanner;

  if (!mediaPartnerBanner) return null;

  const { text, link } = mediaPartnerBanner;
  const { variant, title, url, tracking } = link;

  const outboundTracking = tracking?.outboundTracking;
  if (!outboundTracking) return null;

  return (
    <StreetPageBanner
      text={text}
      variant={variant}
      title={title}
      url={url}
      outboundTracking={outboundTracking}
    />
  );
};
